import {
	FETCH_PHARMACY_PROFILE_REQUEST,
	FETCH_PHARMACY_PROFILE_SUCCESS,
	FETCH_PHARMACY_PROFILE_FAILURE,
} from '../../constants';

import {  pharmacy_user_profile } from '../../../networking/urlEndPoints';
import Axios from '../../../networking/intraceptor';

export const fetchPharmacyProfileRequest = () => ({
	type: FETCH_PHARMACY_PROFILE_REQUEST,
});

export const fetchPharmacyProfileSuccess = (profileData) => ({
	type: FETCH_PHARMACY_PROFILE_SUCCESS,
	payload: profileData,
});

export const fetchPharmacyProfileFailure = (error) => ({
	type: FETCH_PHARMACY_PROFILE_FAILURE,
	payload: error,
});

export const getPharmacyFileManagerUrlRequest = () => ({
	type: 'GET_PHARMACY_FILE_MANAGER_URL_REQUEST',
});

export const getPharmacyFileManagerUrlSuccess = (url) => ({
	type: 'GET_PHARMACY_FILE_MANAGER_URL_SUCCESS',
	payload: url,
});

export const getPharmacyFileManagerUrlFailure = (error) => ({
	type: 'GET_PHARMACY_FILE_MANAGER_URL_FAILURE',
	payload: error,
});

export const getPharmacyAccountabilitySettings = (data) => ({
	type: 'GET_PHARMACY_ACCOUNTABILITY_SETTINGS',
	payload: data,
});

export const getAfterProcessPrepCheckSetting = (data) => ({
	type: 'GET_AFTER_PROCESS_PREP_CHECK_SETTING',
	payload: data,
});

export const fetchUserProfile = () => {
	return async (dispatch) => {
		dispatch(fetchPharmacyProfileRequest());
		try {
			const response = await Axios.get(`${pharmacy_user_profile}`);
			if (response?.status === 200) {
				dispatch(fetchPharmacyProfileSuccess(response?.data));
			} else {
				throw new Error(response);
			}
		} catch (error) {
			if (error?.response) {
				dispatch(fetchPharmacyProfileFailure(error?.response))
			}
		}
	};
};

export const fetchPharmacyFileManagerUrl = () => {
	return async (dispatch) => {
		dispatch(getPharmacyFileManagerUrlRequest());
		try {
			const response = await Axios.get(`get-pharmacy-filemanagerurl`);
			if (response?.status === 200) {
				dispatch(getPharmacyFileManagerUrlSuccess(response?.data?.data?.filemangerurl));
			} else {
				throw new Error(response);
			}
		} catch (error) {
			if (error?.response) {
				dispatch(getPharmacyFileManagerUrlFailure(error?.response))
			}
		}
	};
};
